import { Action } from '@ngrx/store';

export enum ShippingmarksActionTypes {
  ShippingmarksDownloadPDF = '[API] Download shippingmarks pdf',
  ShippingmarksDownload = '[API] Download shippingmarks xlsx',
  ShippingmarksDownloadAll = '[API] Download all shippingmarks xlsx',
  ShippingmarksDownloadSuccess = '[API] Download shippingmarks pdf success',
  ShippingmarksDownloadFail = '[API] Download shippingmarks pdf fail'
}

export class ShippingmarksDownload implements Action {
  readonly type = ShippingmarksActionTypes.ShippingmarksDownload;
  constructor(
    public ProviderId: number,
    public FollowId: number,
    public filename: string
  ) {}
}

export class ShippingmarksDownloadAll implements Action {
  readonly type = ShippingmarksActionTypes.ShippingmarksDownloadAll;
  constructor(
    public FollowId: number,
    public UserId: number,
    public data: any
  ) {}
}
export class ShippingmarksDownloadPDF implements Action {
  readonly type = ShippingmarksActionTypes.ShippingmarksDownloadPDF;
  constructor(
    public ProviderId: number,
    public FollowId: number,
    public filename: string
  ) {}
}

export class ShippingmarksDownloadSuccess implements Action {
  readonly type = ShippingmarksActionTypes.ShippingmarksDownloadSuccess;
  constructor() {}
}

export class ShippingmarksDownloadFail implements Action {
  readonly type = ShippingmarksActionTypes.ShippingmarksDownloadFail;
  constructor(public error: any) {}
}

export type ShippingmarksActionsUnion =
  | ShippingmarksDownload
  | ShippingmarksDownloadPDF
  | ShippingmarksDownloadSuccess
  | ShippingmarksDownloadFail;
